import React from "react";
import { usCurrency } from "../../../../../utils";

const SourceSplitupSummary = ({ data, totalRequestedAmount }) => {
  const sources = data.sourceDetails;
  return (
    <div className="splitup-summary">
      <div className="d-flex justify-content-between">
        <div className="ft-14 fw-500">Total Requested Amount</div>
        <div className="ft-14 fw-500">{totalRequestedAmount}</div>
      </div>
      <div className="loan-line-separator" />
      {sources.map((source) => {
        return (
          <div className="d-flex justify-content-between">
            <div className="ft-14">{source.name}</div>
            <div className="ft-14">{usCurrency(source.amount)}</div>
          </div>
        );
      })}
    </div>
  );
};

export default SourceSplitupSummary;
